<template>
  <v-app id="app">
    <NavBar />
    <v-main>
      <div class="update-dialog" v-if="prompt">
        <div class="update-dialog__content">
          A new version is found. Refresh to load it?
        </div>
        <div class="update-dialog__actions">
          <button
            class="update-dialog__button update-dialog__button--confirm"
            @click="update"
          >
            Update
          </button>
          <button
            class="update-dialog__button update-dialog__button--cancel"
            @click="prompt = false"
          >
            Cancel
          </button>
        </div>
      </div>
      <addToHomeBtn />
      <v-container fluid>
        <v-row>
          <router-view />
        </v-row>
      </v-container>
      <notifications group="action" position="bottom left" />
      <SlideGroups />
    </v-main>
    <AiAccessNotice />
    <Footer />
  </v-app>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import AiAccessNotice from '@/components/common/AiAccessNotice.vue'

export default {
  name: 'App',
  metaInfo: {
    title:
      'LinkBook.io - Your Ultimate Digital Bookmark Companion | Organise and Access Your Bookmarks with Ease',
    meta: [
      {
        name: 'description',
        content:
          'Discover the ultimate digital bookmark companion with LinkBook.io. Effortlessly organise and access your bookmarks from any device. Enjoy a user-friendly interface, smart categorisation, and seamless offline access. Experience the future of bookmarking today.'
      }
    ]
  },
  data() {
    return {
      prompt: false,
      links: ['Home', 'About Us', 'Team', 'Services', 'Blog', 'Contact Us']
    }
  },
  created() {
    this.fetchLinks()
    if (this.$workbox) {
      this.$workbox.addEventListener('waiting', () => {
        this.prompt = true
      })
    }
  },
  components: {
    AiAccessNotice,
    NavBar: () =>
      import(/* webpackChunkName: "layout" */ './components/layout/NavBar'),
    addToHomeBtn: () =>
      import(/* webpackChunkName: "utils" */ './components/utils/addToHomeBtn'),
    SlideGroups: () =>
      import(
        /* webpackChunkName: "layout" */ './components/layout/SlideGroups'
      ),
    Footer: () =>
      import(
        /* webpackChunkName: "layout" */ '../shared/components/layout/Footer.vue'
      )
  },
  computed: {
    ...mapGetters(['getLinks', 'getTeamsWorkspaceLinks'])
  },
  methods: {
    ...mapActions(['fetchLinks', 'fetchTeamsWorkspaceLinks']),
    async update() {
      this.prompt = false
      await this.$workbox.messageSW({ type: 'SKIP_WAITING' })
    }
  }
}
</script>

<style lang="sass">
@import './assets/sass'
</style>
